import NewsletterContainer from "./containers/newsletterContainer";
export default NewsletterContainer;
